import './chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.InvalidChartView extends CustomerVisualMode.Charts.ChartView
  className: 'grid-item full-width-chart'
  @NAME: 'invalid_widget'

  initialize: (widget, isResponsive, isReadOnly) ->
    title = I18n.t('customer_visual_mode.charts.invalid_chart.title')
    description = I18n.t('customer_visual_mode.charts.invalid_chart.description')
    super({widget, title, description, data: {}, session: null, isReadOnly, isResponsive})

  render: ->
    super()
    @$('.insert-note').addClass('hidden')
    @
